import { StaleTime, useQuery } from '@tanstack/react-query';
import { getTerminalReader } from '../../services/business';
import useUser from '../global/useUser';

type Reader = Awaited<ReturnType<typeof getTerminalReader>>['reader'];

interface Options {
  staleTime?: StaleTime<Reader>;
  gcTime?: number;
}

function useTerminalReader(
  options: Options = {
    staleTime: 0,
    gcTime: 0,
  },
) {
  const { user } = useUser();

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      'business-terminal-reader',
      user?.business.id,
      user?.business?.terminalReaderId,
    ],
    queryFn: async () => {
      const { reader } = await getTerminalReader(user!.business.id);
      return reader;
    },
    enabled: !!user?.business.id && !!user?.business?.terminalReaderId,
    ...options,
  });
}

export default useTerminalReader;
